import { Link } from 'react-router-dom';
import { SITE } from '../data/site';
import './Footer.css';

export function Footer() {
  const year = 2026; // fixed launch-era stamp; bump alongside legalLastUpdated

  return (
    <footer className="foot">
      <div className="foot__inner shell">
        <div className="foot__brand">
          <span className="foot__wordmark">ARCADIA&rsquo;84</span>
          <p className="foot__blurb">
            A fictional 1984 arcade, rebuilt in full 3D. Twenty neon cartridges,
            playable free in your browser.
          </p>
          <a className="btn foot__cta" href={SITE.appUrl}>
            ENTER THE ARCADE &#9656;
          </a>
        </div>

        <nav className="foot__col" aria-label="Arcade">
          <h3 className="foot__head">ARCADE</h3>
          <a href={SITE.appUrl}>Play the cabinet</a>
          <Link to="/#games">The games</Link>
          <Link to="/#passes">Passes</Link>
        </nav>

        <nav className="foot__col" aria-label="Studio">
          <h3 className="foot__head">STUDIO</h3>
          <Link to="/about">About</Link>
          <Link to="/contact">Contact</Link>
          <a href={SITE.studioUrl} target="_blank" rel="noreferrer">
            {SITE.studio}
          </a>
          <a href={SITE.legalEntityUrl} target="_blank" rel="noreferrer">
            {SITE.legalEntity}
          </a>
        </nav>

        <nav className="foot__col" aria-label="Legal">
          <h3 className="foot__head">LEGAL</h3>
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/terms">Terms of Service</Link>
          <Link to="/cookies">Cookie Policy</Link>
        </nav>
      </div>

      <div className="foot__baseline shell">
        <span>
          &copy; {year}{' '}
          <a href={SITE.legalEntityUrl} target="_blank" rel="noreferrer">
            {SITE.legalEntity}
          </a>
          . All rights reserved.
        </span>
        <span className="foot__sig">EST. 1984 &middot; REBUILT IN FULL 3D</span>
      </div>
    </footer>
  );
}
